<template>
  <div>
    <div v-if="isUserLogged">
      <vv-section-title class="Title">{{ welcomeMessage }}</vv-section-title>
    </div>

    <AccountChecker v-else />

    <!-- <vv-collapsable :title="'Adresse de facturation'" :name="'facturation'">
      <CartUserInformations />
    </vv-collapsable> -->

    <!-- @TODO - Check if there is a physical product or not to display it -->
    <!-- <vv-collapsable :title="'Mode de Livraison'" :name="'adresse'">
      <CartUserShipping />
    </vv-collapsable> -->

    <vv-collapsable :title="'Mon panier'" :name="'panier'">
      <CartSummary />
    </vv-collapsable>
  </div>
</template>

<script>
import VvCollapsable from '@/components/common/VvCollapsable'
import userMixin from '@/mixins/user'
import CartUserInformations from '@/components/shop/cart/CartUserInformations'
import AccountChecker from "@/components/shop/cart/AccountChecker";
// import CartUserShipping from "@/components/shop/cart/CartUserShipping";
import CartSummary from "@/components/shop/cart/CartSummary";
import VvSectionTitle from "@/components/common/VvSectionTitle";
import { UPDATE_CHECKOUT_INFORMATIONS } from "@/store/modules/shop/types";

export default {
  name: 'CartInformations',
  components: {
    VvSectionTitle,
    CartSummary,
    // CartUserShipping,
    AccountChecker,
    CartUserInformations,
    VvCollapsable
  },
  mixins: [
    userMixin
  ],
  computed: {
    welcomeMessage() {
      if (this.user && this.user.firstname) {
        return this.$t('shop.cartInformations.title', { firstname: this.user.firstname })
      } else {
        return this.$t('shop.cartInformations.titleAnonymous')
      }
    }
  },
  mounted() {
    this.$store.dispatch(UPDATE_CHECKOUT_INFORMATIONS, {
      email: this.userEmail ? this.userEmail : ''
    })
  }
}
</script>

<style lang="scss" scoped>
.Title {
  margin-top: 93px;
  margin-bottom: 70px;
}
</style>